import { NotificationExtension } from "../_base/extension/NotificationExtension";
import { HanderResponse } from "../_base/helper/FunctionHelper";
import { API_ROUTE } from "../const/apiRoute";
import { api } from "../library/axios";

// Block trang chủ, bảng TBL_HOME (api-web TblHomeController).
// Metadata block là cột riêng; cấu hình chi tiết của block là chuỗi JSON ở cột Data.

// Một dòng get-list trả về (TblHomeModel, tên trường camelCase).
// template, desktop, mobile, from_, to_ là cột của bảng nhưng get-list có thể chưa trả, nên để tuỳ chọn.
export type TblHomeRow = {
  id: string;
  stt?: string | number | null;
  code?: string | null;
  title?: string | null;
  data?: string | null;
  isVisible?: boolean | null;
  template?: string | null;
  desktop?: boolean | null;
  mobile?: boolean | null;
  from_?: string | null;
  to_?: string | null;
};

// Dữ liệu gửi lên create / edit, khớp TblHomeCommand / TblUpdateHomeCommand.
// Không gửi ngày tạo/sửa, người tạo/sửa: API tự xử lý.
export type TblHomeInput = {
  // Chỉ dùng cho edit để tìm dòng; create để API tự sinh
  id: string;
  stt: string;
  code: string;
  title: string;
  data: string;
  isVisible: boolean;
  template: string;
  desktop: boolean;
  mobile: boolean;
  // Ngày giờ dạng YYYY-MM-DDTHH:mm:ss (giờ Việt Nam), "" = không giới hạn
  from_: string;
  to_: string;
};

// Lỗi chung (mất mạng, hết phiên, không có quyền, lỗi máy chủ) dùng thông báo sẵn có; còn lại hiện message của API
const reportError = (error: any, fallback: string) => {
  const status = error?.response?.status;
  if (error?.code === "ERR_NETWORK" || [401, 403, 404, 500].includes(status)) {
    HanderResponse(error);
    return;
  }
  NotificationExtension.Fails(error?.response?.data?.message ?? fallback);
};

const succeeded = (res: any, fallback: string) => {
  if (res?.data?.success) return true;
  NotificationExtension.Fails(res?.data?.message ?? fallback);
  return false;
};

// get-list trả thẳng danh sách phân trang { count, lists }, không bọc { success, data }.
// Lỗi thì trả null để màn hình hiện trạng thái lỗi và cho tải lại.
export const getTblHomeList = async (): Promise<TblHomeRow[] | null> => {
  try {
    const res = await api.get(`${API_ROUTE.TBL_HOME_GET_LIST}?Skip=0&Take=1000`);
    const body = res.data;
    const list = body?.lists ?? body?.Lists ?? body?.data?.lists ?? body?.data;
    return Array.isArray(list) ? list : [];
  } catch (error) {
    reportError(error, "Không tải được danh sách block trang chủ");
    return null;
  }
};

// create nhận JSON. Id, ngày tạo, người tạo do API tự xử lý nên không gửi
export const createTblHome = async (input: Omit<TblHomeInput, "id">) => {
  try {
    const res = await api.post(API_ROUTE.TBL_HOME_CREATE, input);
    return succeeded(res, "Thêm block thất bại");
  } catch (error) {
    reportError(error, "Thêm block thất bại");
    return false;
  }
};

// edit nhận form-data và ghi đè mọi trường, nên luôn gửi đủ. Id để API tìm dòng; người sửa, ngày sửa API tự gán
export const updateTblHome = async (input: TblHomeInput) => {
  const form = new FormData();
  Object.entries(input).forEach(([key, value]) => {
    if (value !== undefined && value !== null) form.append(key, String(value));
  });
  try {
    const res = await api.put(API_ROUTE.TBL_HOME_EDIT, form, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return succeeded(res, "Lưu block thất bại");
  } catch (error) {
    reportError(error, "Lưu block thất bại");
    return false;
  }
};

export const deleteTblHome = async (ids: string[]) => {
  try {
    const res = await api.delete(API_ROUTE.TBL_HOME_DELETE, { data: ids });
    return succeeded(res, "Xoá block thất bại");
  } catch (error) {
    reportError(error, "Xoá block thất bại");
    return false;
  }
};

export const updateTblHomeStt = async (items: { id: string; stt: number }[]) => {
  try {
    const res = await api.put(API_ROUTE.TBL_HOME_UPDATE_STT, { items });
    return succeeded(res, "Lưu thứ tự block thất bại");
  } catch (error) {
    reportError(error, "Lưu thứ tự block thất bại");
    return false;
  }
};
